import { getDistanceScales, zoomToScale } from '@math.gl/web-mercator';

const calculateMapScale = (
  latitude: number,
  longitude: number,
  zoom: number
): number => {
  // 与えられた地点の緯度・経度に基づいて、1pxあたりのメートル数を計算する
  const { unitsPerMeter } = getDistanceScales({
    longitude: longitude,
    latitude: latitude,
    highPrecision: true,
  });
  const meterPerPixel = 1 / unitsPerMeter[0];

  // ズームレベルに基づく拡大率を計算する
  const scale = zoomToScale(zoom);

  // 拡大率で割ることで、地図の縮尺(1pxあたりのメートル数)を計算する
  return meterPerPixel / scale;
};

export { calculateMapScale };
